// src/redux/sagas/rootSaga.js
import { takeEvery, call, put } from "redux-saga/effects";
import axios from "axios";
import { API_REQUEST, API_SUCCESS, API_FAILURE } from "../Redux/apiActions";

function* handleApi(action) {
  const {
    url,
    method = "GET",
    data = null,
    headers = {},
    handleSuccess,
    handleError,
    onSuccessKey,
    onErrorKey,
  } = action.payload;
  const key = onSuccessKey || url;
//console.log("onErrorKey",onErrorKey)
  try {
    const jwtToken = localStorage.getItem("UserJWTAuth");
    const config = {
      url,
      method,
      headers: {
        "Content-Type": "application/json",
        ...headers,
        ...(jwtToken ? { Authorization: `Bearer ${jwtToken}` } : {}),
      },
      data,
    };

    const response = yield call(axios, config);

    //console.log("response saga",response)

    // Dispatch generic success for state
    yield put({ type: API_SUCCESS, payload: { key, data: response.data } });

    // Dispatch custom success action if needed
    if (onSuccessKey) yield put({ type: onSuccessKey, payload: response.data });

    // Call callback
    if (handleSuccess) handleSuccess(response);
  } catch (error) {
    yield put({ type: API_FAILURE, payload: { key, error: error.message } });

    if (onErrorKey) yield put({ type: onErrorKey, payload: error.message });

    if (handleError) handleError(error);
  }
}

export default function* rootSaga() {
  yield takeEvery(API_REQUEST, handleApi);
}
